/**
 * 对bridge扩展或处理顺风车bridge相关API 支持情况见文档
 * wiki-beatles-bridge-API bridge: http://fe.in.didialift.com:8088/fe/hudamin/didibridge.md.html#nav_24
 * wiki-beatles-beatlesCommunicate-API bridge: http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=79447904
 * wiki-common bridge: http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=94909837
 */
import {
  getAppVersion,
  extendSimple,
  compareVersion,
  entranceConfigAlias,
  shareConfigAlias,
  noop,
  isIos,
  isFusionKit,
  mockOrCall
} from './util';

import {
  getWindow
} from '../util';
let theWindow = getWindow();

import schemes from './schemes';

import {
  callHandler,
  beatlesCommunicate,
  callNative,
  listenNative
} from './call';

// 需要别名处理的方法
import {
  aliasWithBridge4,
  aliasWithBridge5
} from './alias';

/**
 * 支持顺风车bridge特殊方法
 * 以下方法为顺风车使用bridge需要处理或补充的方法，保证bridge方法均可用。其他未提到的bridge方法（如getUserInfo等）均为可用，
 * 只在callback里做了返回参数兼容，在此不做处理。
 * 需要必须走老协议（4.x）的请使用callHandler
 * @param DDbridge
 */
export function extendBeatlesAPI(DDbridge) {
  extendSimple(DDbridge, {
    schemes: schemes,
    callHandler: callHandler,
    callNative: callNative,
    listenNative: listenNative,
    beatlesCommunicate: beatlesCommunicate,
    check: DDbridge.support,
    appVersion: getAppVersion(DDbridge.app.version),
    compareVersion: compareVersion,
    updateNaviTitle: function (titleObj) {
      DDbridge.setTitle({
        title: titleObj.navi_title || titleObj.title
      });
    },
    /**
     * 安卓使用自己协议的登录 callNative('callNativeLogin', {}, cb)，平台回回到首页弹登录框，不符合业务
     * iOS使用平台方法
     */
    callNativeLoginWithCallback: function (cb) {
      cb = cb || noop;
      if (isFusionKit()) {
        DDbridge.call('callNativeLoginWithCallback', {
          needStopReload: true
        }, cb);
      } else {
        callHandler('callNativeLoginWithCallback', {
          needStopReload: true
        }, cb);
      }
    },
    openUrl: function (params) {
      callHandler(aliasWithBridge4['openUrl'], params);
    },
    initEntrance: function (opts, cb) {
      let me = this;
      me.cb = cb || noop;
      me.opts = opts || {};
      if (isIos()) {
        theWindow['__showEntranceCallBack__'] = cb || function () {};
        extendSimple(opts, {
          'windowCallBack': '__showEntranceCallBack__'
        });
      }
      entranceConfigAlias(opts);
      DDbridge.call('initEntrance', opts, cb);
    },
    /**
     * 必须先initEntrance，才能有回调，端上bug
     */
    showEntrance: function () {
      let me = this;
      if (!me.opts) {
        throw new Error('请先initEntrance');
      }
      if (isIos()) {
        theWindow['__showEntranceCallBack__'] = me.cb || function () {};
        extendSimple(me.opts, {
          'windowCallBack': '__showEntranceCallBack__'
        });
      }
      entranceConfigAlias(me.opts);

      // 需要延迟才能和initEntrance生效
      setTimeout(function () {
        DDbridge.call('showEntrance', me.opts, me.cb);
      }, 300);
    },
    // 延迟隐藏，因为showEntrance延迟了
    hideEntrance: function () {
      setTimeout(function () {
        DDbridge.call('hideEntrance');
      }, 360);
    },
    invokeEntrance: function () {
      let me = this;
      entranceConfigAlias(me.opts);
      DDbridge.call('invokeEntrance', me.opts, me.cb);
    },
    // 以下直接渠道分享，需要先initEntrance或showEntrance才可触发回调，ios实现bug，回调用这里的回调。。坑。
    shareWxAppmsg: function (shareConfig, cb) {
      shareConfigAlias(shareConfig);
      DDbridge.call(aliasWithBridge5['shareWxAppmsg'], shareConfig, cb);
    },
    shareWxTimeline: function (shareConfig, cb) {
      shareConfigAlias(shareConfig);
      DDbridge.call(aliasWithBridge5['shareWxTimeline'], shareConfig, cb);
    },
    shareQQAppmsg: function (shareConfig, cb) {
      shareConfigAlias(shareConfig);
      DDbridge.call(aliasWithBridge5['shareQQAppmsg'], shareConfig, cb);
    },
    shareQZone: function (shareConfig, cb) {
      shareConfigAlias(shareConfig);
      DDbridge.call(aliasWithBridge5['shareQZone'], shareConfig, cb);
    },
    shareSinaWeibo: function (shareConfig, cb) {
      shareConfigAlias(shareConfig);
      DDbridge.call(aliasWithBridge5['shareSinaWeibo'], shareConfig, cb);
    },
    uploadImageBySelect: function (config, cb) {
      let uploadCb = 'uploadCallback' + Date.now();
      theWindow[uploadCb] = cb || noop;
      config.callback = uploadCb;
      config.outputWidth = config.outputWidth || 800;
      config.outputHeight = config.outputHeight || 800;
      if (isFusionKit()) {
        DDbridge.call(aliasWithBridge4['uploadImageBySelect'], config, theWindow[uploadCb]);
      } else {
        callHandler(aliasWithBridge4['uploadImageBySelect'], config, theWindow[uploadCb]);
      }
    },
    uploadImageByCamera: function (config, cb) {
      let uploadCb = 'uploadCallback' + Date.now();
      theWindow[uploadCb] = cb || noop;
      config.callback = uploadCb;
      config.outputWidth = config.outputWidth || 800;
      config.outputHeight = config.outputHeight || 800;
      if (isFusionKit()) {
        DDbridge.call(aliasWithBridge4['uploadImageByCamera'], config, theWindow[uploadCb]);
      } else {
        callHandler(aliasWithBridge4['uploadImageByCamera'], config, theWindow[uploadCb]);
      }
    },
    uploadImageByPhotoLibrary: function (config, cb) {
      let uploadCb = 'uploadCallback' + Date.now();
      theWindow[uploadCb] = cb || noop;
      config.callback = uploadCb;
      config.outputWidth = config.outputWidth || 800;
      config.outputHeight = config.outputHeight || 800;
      if (isFusionKit()) {
        DDbridge.call(aliasWithBridge4['uploadImageByPhotoLibrary'], config, theWindow[uploadCb]);
      } else {
        callHandler(aliasWithBridge4['uploadImageByPhotoLibrary'], config, theWindow[uploadCb]);
      }
    },

    /**
     * 端上后来兼容的方法
     * var eventkey = 'entranceAndroidBugCallback_' + new Date().getTime();
     * Didibridge.showEntranceAndroidBug({
     *     windowCallBack: eventkey
     * });
     */
    showEntranceAndroidBug: function (opt) {
      callHandler('showEntranceAndroidBug', opt);
    },

    // mock data out of didi app
    getSystemInfo: function (cb) {
      mockOrCall(DDbridge, 'getSystemInfo', {}, cb);
    },
    getLocationInfo: function (cb) {
      mockOrCall(DDbridge, 'getLocationInfo', {}, cb);
    },
    getUserInfo: function (cb) {
      mockOrCall(DDbridge, 'getUserInfo', {}, cb);
    },
    startRecognition: function (opts, cb) {
      mockOrCall(DDbridge, 'startRecognition', opts, cb);
    },
    stopRecognition: function (opts, cb) {
      mockOrCall(DDbridge, 'stopRecognition', opts, cb);
    },
    cancelRecognition: function (opts, cb) {
      mockOrCall(DDbridge, 'cancelRecognition', opts, cb);
    },
    startRecord: function (opts, cb) {
      mockOrCall(DDbridge, 'startRecord', opts, cb);
    },
    endRecord: function (opts, cb) {
      mockOrCall(DDbridge, 'endRecord', opts, cb);
    }
  });
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/beatles/extendApi.js